import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import {
    AparenciaBotaoGenerico,
    IBotaoGenerico,
} from '../../interface/icm-botoes-generico';
import { IRetornoBotao } from '../../interface/icm-retorno-botao';

@Component({
    selector: 'icm-coluna-botao',
    templateUrl: './view/icm-coluna-botao.component.html',
    styleUrls: ['./view/icm-coluna-botao.component.scss'],
})
export class IcmColunaBotaoComponent implements OnInit {
    @Input() botao: IBotaoGenerico;
    @Input() linha;
    @Input() carregando: boolean;
    @Input() colunaComTexto: boolean = false;

    @Output() expandirClicado = new EventEmitter<IRetornoBotao<any>>();

    exibirSe: boolean = true;
    desabilitarSe: boolean = false;
    textoTooltip: string;
    icone: string;
    cor: string = '#000000de';
    corDesabilitado: string = '#00000042';
    corFundoDesabilitado: string = '#96969642';
    corFundo: string;
    corTexto: string;
    titulo: string;
    aparencia: AparenciaBotaoGenerico = 'icon';

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        if (this.botao?.icone) {
            this.icone = this.botao.icone.valor(this.linha);
            this.textoTooltip = this.botao.icone.tooltip.valor(this.linha);

            if (this.botao.icone?.cor) {
                this.cor = this.botao.icone.cor(this.linha);
            }
        }

        if (this.botao?.exibirSe) {
            this.exibirSe = this.botao.exibirSe(this.linha);
        }

        if (this.botao?.desabilitarSe) {
            this.desabilitarSe = this.botao.desabilitarSe(this.linha);
        }

        if (this.botao?.corFundo) {
            this.corFundo = this.botao.corFundo(this.linha);
        }

        if (this.botao?.aparencia) {
            this.aparencia = this.botao.aparencia;

            if (this.botao.aparencia === 'flat') {
                this.titulo = this.botao.titulo(this.linha);

                if (this.botao?.corTexto) {
                    this.corTexto = this.botao.corTexto(this.linha);
                }
            }
        }
    }

    aoClicar() {
        const retorno: IRetornoBotao<any> = {
            id: this.botao.id,
            linha: this.linha,
        };
        if (this.botao.ehExpansivel) this.expandirClicado.emit(retorno);
        this.botao.aoClicar(retorno);
    }
}
